import { ClientConfigProductName } from '@frontend/vanilla/core';

export const ScoreboardCarouselLoader = {
    id: 'scoreboard-carousel',
    loaderFn: () => import(/* webpackChunkName: "ms-scoreboard-carousel-widget" */ './scoreboard-carousel.feature'),
    product: ClientConfigProductName.SPORTS,
};
